module.exports = __webpack_public_path__ + "media/images/athletes/3546-4013af1ab79de5ab315457d6c8d2b00c.png";